<div class="container pt-4">
    <div class="row">
        <div class="col">
            <h4 class="border-bottom pb-2 color-primary mb-3">{{'VSS.ORGANIZATION.title' | translate}}
                <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                    {{'VSS.ORGANIZATION.titleHelpText' | translate}}
                </small>
            </h4>
        </div>
    </div>
    <div class="row" *ngIf="loading">
        <div class="col">
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!loading">
        <div class="col">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">{{'VSS.ORGANIZATION.TABLE.id' | translate}}</th>
                        <th scope="col">{{'VSS.ORGANIZATION.TABLE.name' | translate}}</th>
                        <!-- // favorites, please uncomment after client confirmation
                          <th scope="col"></th>
                        -->
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let organization of tableOgranizations">
                        <tr>
                            <th scope="row">{{organization.id}}</th>
                            <td>{{organization['name_'+currentLanguage]}} </td>
                            <!-- // favorites, please uncomment after client confirmation
                            <td style="text-align: center;">
                              <ng-container *ngIf="organization['favorites'] > 0">
                                <fa-icon [icon]="icons['faHeart']" class="fa-1x" style="color:red"></fa-icon>&nbsp;<b>{{organization['favorites']}}</b>
                              </ng-container>
                            </td>
                            -->

                            <td class="text-end">
                                <a [routerLink]="['organization', organization.id, 'informations']"
                                    class="btn btn-sm btn-outline-secondary">
                                    <fa-icon [icon]="icons['faEdit']"></fa-icon> {{'VSS.ORGANIZATION.edit' | translate}}
                                </a>
                            </td>
                        </tr>
                        <tr *ngIf="organization.children">
                            <td colspan="4">
                                <table class="table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">{{'VSS.ORGANIZATION.TABLE.id' | translate}}</th>
                                            <th scope="col">{{'VSS.ORGANIZATION.TABLE.name' | translate}}</th>
                                            <!-- // favorites, please uncomment after client confirmation
                                            <th scope="col"></th>
                                            -->
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let child of organization.children">
                                            <th scope="row">{{child.id}}</th>
                                            <td>{{child['name_'+currentLanguage]}}
                                                <ng-container *ngFor="let sportCat of child.sportCategories">
                                                    <em>- {{sportCat['name_'+currentLanguage]}}</em>
                                                </ng-container>
                                            </td>
                                            <!-- // favorites, please uncomment after client confirmation
                                              <td style="text-align: center;">
                                                <ng-container *ngIf="child['favorites'] > 0">
                                                  <fa-icon [icon]="icons['faHeart']" class="fa-1x" style="color:red"></fa-icon>&nbsp;<b>{{child['favorites']}}</b>
                                                </ng-container>
                                              </td>
                                            -->
                                            <td class="text-end">
                                                <a [routerLink]="['organization', child.id, 'informations']"
                                                    class="btn btn-sm btn-outline-secondary">
                                                    <fa-icon [icon]="icons['faEdit']"></fa-icon>
                                                    {{'VSS.ORGANIZATION.edit' |
                                                    translate}}
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
